<ng-container *ngIf="selection$ | async as selection">
    <ng-container>
        <button mat-icon-button data-automation-id="smt-action-button-excel-export" (click)="download(selection)"
            [attr.aria-label]="'ALDEN.ACTIONS.EXCEL_EXPORT' | translate"
            [attr.title]="'ALDEN.ACTIONS.EXCEL_EXPORT' | translate">
            <img class="icon" src="assets/alden-extension/images/export-excel.png" />
        </button>
    </ng-container>
</ng-container>

<ng-template>
    <span>{{ 'ALDEN.ACTIONS.EXCEL_EXPORT' | translate }}</span>
</ng-template>